"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacySelectBox = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'selectbox';
const getItemValue = (item) => {
    if (typeof item === 'object') {
        const value = item.value;
        return typeof value !== 'number' ? value : value.toString();
    }
    else {
        return item;
    }
};
const sameValue = (item, value) => {
    const toString = (x) => {
        if (typeof x === 'number')
            return `${x}`;
        return x;
    };
    return toString(getItemValue(item)) === toString(value);
};
const filterItem = (item) => {
    if (typeof item !== 'object')
        return true;
    const hidden = item.hidden;
    return !hidden;
};
const getItemName = (item) => typeof item === 'object' ? item.name : item;
const OptionItem = (props) => {
    const { item } = props;
    const itemNameValue = getItemName(item);
    const isReactElement = react_1.default.isValidElement(itemNameValue);
    if (isReactElement) {
        // processing of the FormattedMessage `name` property
        const originalProps = itemNameValue.props;
        return (react_1.default.createElement(react_intl_1.FormattedMessage, { ...originalProps }, message => (react_1.default.createElement("option", { value: getItemValue(item), key: getItemValue(item) }, message))));
    }
    return (react_1.default.createElement("option", { value: getItemValue(item) }, itemNameValue));
};
/** @deprecated Use SelectBox */
const LegacySelectBox = (props) => {
    const { placeholder = '', items, modificators, onSelect, onChange, ...restProps } = props;
    const { value, disabled } = restProps;
    const isEmptyValue = Array.isArray(items) && items.some(item => !item);
    const mappedItems = items === null || items === void 0 ? void 0 : items.filter(filterItem).map((item, idx) => (react_1.default.createElement(OptionItem, { item: item, key: idx })));
    const namedValue = items ? (items).reduce((acc, item) => {
        if (acc !== null) {
            return acc;
        }
        return sameValue(item, value) ? getItemName(item) : null;
    }, null) : '';
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        disabled ? 'disabled' : undefined,
    ]);
    const selectOnChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        const item = items === null || items === void 0 ? void 0 : items.find(x => sameValue(x, event.target.value));
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(item);
    };
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__values ${!namedValue && `${className}__values--placeholder`}` }, namedValue || placeholder),
        react_1.default.createElement("div", { className: `${className}__arrow` },
            react_1.default.createElement("i", null)),
        react_1.default.createElement("select", { id: 'select', ...restProps, onChange: selectOnChange },
            !namedValue && !isEmptyValue && (react_1.default.createElement("option", null)),
            mappedItems)));
};
exports.LegacySelectBox = LegacySelectBox;
//# sourceMappingURL=legacy.js.map